import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Unica lectura y normalizacion del querystring del checkout.
 *
 * Las reglas de saneo viven SOLO aca: antes cada pantalla parseaba por su cuenta
 * y normalizaba distinto (BonusesInfoModal releia "t", "em" se leia crudo).
 *
 * - t: lowercase y ACOTADO a los tipos conocidos (g, p, e, m); cualquier otra cosa
 *   (ej. "t=g=" por un typo en el link) cae al default 'g' en vez de reventar la
 *   pagina con typeConfig[t] undefined.
 * - fi, token: lowercase (ids y fechas, case-insensitive).
 * - c, p: trim (los ids char de SIGUE traen padding).
 * - em, l: Base64 => NO lowercase, y se restauran los "+" que el querystring
 *   decodifica como espacios. Sin eso, un cifrado con "+" llega corrupto: el
 *   link roto no falla, simplemente pierde la atribucion (em) o el tipo de
 *   asistente (l) en silencio.
 * - e: entidad (UAI, CEE, 24O, LDV, BEL, ALB, GAL, OXF, CESYT) => upper, default
 *   'UAI'. Es solo un codigo: la base de cada entidad la resuelve NBAPI con una
 *   lista blanca; el front nunca conoce ni manda nombres de base.
 */
// Tipos de programa que el checkout conoce (claves de config/typeConfig.js).
const TIPOS_VALIDOS = ['g', 'p', 'e', 'm'];

export const parseCheckoutParams = (search) => {
  const params = new URLSearchParams(search);
  const t = params.get('t')?.trim().toLowerCase();
  return {
    e: params.get('e')?.trim().toUpperCase() || 'UAI',
    t: TIPOS_VALIDOS.includes(t) ? t : 'g',
    c: params.get('c')?.trim() || null,
    p: params.get('p')?.trim() || null,
    fi: params.get('fi')?.toLowerCase() || null,
    token: params.get('token')?.toLowerCase() || null,
    em: params.get('em')?.replace(/ /g, '+') || null,
    l: params.get('l')?.replace(/ /g, '+') || null,
  };
};

export const useCheckoutParams = () => {
  const { search } = useLocation();
  return useMemo(() => parseCheckoutParams(search), [search]);
};

export default useCheckoutParams;
